const subAbas = [{ label: 'Início', rota: '/fornecedor/home/inicio' }];

export default subAbas;
